import gql from 'graphql-tag';
import suggestionCandidateFragmentInAdder from '../fragments/suggestionCandidateInAdder';

export default gql`
  query keywordSuggestions(
    $suggestionsListId: ID!
    $keyword: String!
    $tenantId: ID!
  ) {
    keywordSuggestions(
      tenant: $tenantId
      suggestionsListId: $suggestionsListId
      keyword: $keyword
      count: 50
    ) {
      id
      entries {
        ...suggestionCandidateInAdder
      }
    }
  }
  ${suggestionCandidateFragmentInAdder}
`;
